import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-info-bg-beige-svg-icon',
  imports: [NgClass],
  templateUrl: './info-bg-beige-svg-icon.component.html',
  styleUrl: './info-bg-beige-svg-icon.component.css',
})
export class InfoBgBeigeSvgIconComponent {
  @Input() class = 'w-8 h-8';
}
